import React, { forwardRef, useCallback, useEffect, useMemo, useState } from 'react';
import { withStyles } from '@material-ui/styles';
import cn from 'classnames';
import styles from '../styles';
import { makeStyles } from '@material-ui/core';
import { useFormContext, useWatch } from 'react-hook-form';

const useStyles = makeStyles(styles);

const Image = ({ watches, setField, computeSrc, registration, labelStyle, imageStyle, className }, ref) => {
  const classes = useStyles();
  const [src, setSrc] = useState(null);

  const formMethods = useFormContext();
  const files = useWatch({
    control: formMethods.control,
    name: watches,
  });

  const findSrc = async () => {
    if (computeSrc) {
      const updatedSrc = await computeSrc(files);

      setSrc(updatedSrc);

      if (setField) {
        formMethods.setValue(setField, updatedSrc);
      }
    }
  };

  useEffect(() => {
    findSrc();
  }, files);

  // const { field, label, direction, disabledOnEdit, disabled, validate } = i;

  // const isDisabled = disabled || (disabledOnEdit && mode === 'EDIT');

  return (
    <div className="col-start-start">
      <label
        style={{
          border: '1px solid black',
          padding: '6px 12px',
          cursor: 'pointer',
          ...labelStyle,
        }}
      >
        <input
          // props from user
          type="file"
          style={{ display: 'none' }}
          //
          // props from react-hook-forms
          {...registration}
        />
        Choose an image
      </label>

      <div style={{ position: 'relative', width: '100%', minHeight: 100, marginTop: 15 }}>
        {!src && (
          <span
            className="row-center-center"
            style={{
              border: '1px solid gray',
              borderRadius: 10,
              position: 'absolute',
              top: 0,
              right: 0,
              bottom: 0,
              left: 0,
              opacity: 0.5,
            }}
          >
            No image
          </span>
        )}

        <img
          src={src}
          style={{
            width: '100%',
            display: 'flex',
            ...(!!src ? imageStyle : {}),
          }}
          className={className}
        />
      </div>
    </div>
  );
};

export default forwardRef(Image);
